module.exports = __webpack_public_path__ + "static/grecianIsleRules-select-min.be1ced6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructional/grecianIsleRules-select-min.jpg
// module id = 148
// module chunks = 66570062548345 213534597649335